import React, { Component } from 'react';
import {Form} from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';

import { crewTimesheetListAction} from '../../../actions/crewActions';
import { clearAction } from '../../../actions/commonActions';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';
import { showStaffPayDetails } from '../../commons/timesheetUtilities';  

import {userGroupUrlCheck,getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import { converDateToLocal,convertDecimalToHHMM } from '../../../utils/commonUtilities';

import * as types from '../../../actions';
import { LBL_SHIFT, LBL_EVENT_TITLE, LBL_LOCATION, LBL_START_CHECKIN_TIME, LBL_END_CHECKOUT_TIME, LBL_CREW_PAY,LBL_SCHEDULED_HRS, LBL_ACTUAL_HRS, LBL_OT_HRS, LBL_APPROVAL_STATUS,LBL_EDIT,LBL_OTHER_EXP, LBL_SKILL_PAY, LBL_CHIEF_BONUS, LBL_PAY_LEVEL, LBL_OT, LBL_DRIVER_PAY_RATE, LBL_PASSENGER_PAY_RATE } from '../../../configs/labelConfigs'; 
import { MSG_NOT_FOUND, MSG_SERVER_DATA_FETCH_ERROR, MSG_TIMESHEET_CSV_ERROR } from '../../../configs/msgConfigs'; 
import {URL_IMG} from '../../../configs/urlConfigs';
import {SCHEDULE_CREW_STATUS,PAGING_END_INDEX,PAGENUMROWS_AFFILIATE} from '../../../configs/staticConfigs';


class CrewTimesheet extends Component {

    constructor(props){
        super(props)
        this.state = {
            activePage:1,
            startIndex : 0, 
            endIndex : PAGING_END_INDEX,
            activeRowId:0,    
            perPageCount: PAGENUMROWS_AFFILIATE,
            sortField:'-created_on',
            sortOrder:'', 
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,          
            timesheetShiftList:[],
            selectedTimesheetId:0,
            approvedEventStatus:true,
            actionNeeded:true,
            otLengthError: '',
            noRowsError: '',
            isClientPage:false,
            clientId:0,
            timesheetCrewId: ''       
        }
    }

    setToasterState = (isEnabled,message,isSucces,isAutoHide=true) => {
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 4000);
        }    
    }

    
    callToaster = (isEnabled,message,isSucces) =>  {
        this.props.setToasterState(isEnabled,message,isSucces);
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    componentDidUpdate(prevProps){
        const { subactivity, status, errorData, crewTimesheetData} = this.props; 

        if(this.props.crewId && this.state.timesheetCrewId!=this.props.crewId) { 
            this.setState({timesheetCrewId:this.props.crewId}, () => {
                this.callCrewTimesheet(); 
            })
        }

        let arrResp = subactivity ? subactivity.split('~~') : []; 
        let actString = arrResp[0] ? arrResp[0] : ''; 
        
        if(actString===types.CREW_TIMESHEET_LIST_SUCCESS){  
            let timesheet = []; 
            timesheet = crewTimesheetData.results; 
            // timesheet = crewTimesheetData.map(item => {
            //     item['isExpand'] = true;
            //     item['shift'] = item.shift_details;
            //     return item;
            // });
            this.setState({timesheetShiftList:timesheet}); 
        }
        else if(actString===types.CREW_TIMESHEET_LIST_ERROR){  
            this.setToasterState(true,MSG_SERVER_DATA_FETCH_ERROR,false);
        }
        else if(actString===types.TIMESHEET_CSV_DOWNLOAD_ERROR){ 
            this.setToasterState(true,MSG_TIMESHEET_CSV_ERROR,false);
        }

    }

    componentDidMount() {
        // this.callCrewTimesheet(); 
    }

    callCrewTimesheet = () => {
        if(this.props.crewId) { 
            this.props.crewTimesheetListAction({crew_id:this.props.crewId,pageSize:this.state.perPageCount,page:this.state.activePage}); 
        }
    }

    onPagePrevious = (e) =>{
        const {
            startIndex, endIndex        
        } = this.state
        let previousPage = startIndex+1-PAGING_END_INDEX
        this.props.crewTimesheetListAction({crew_id:this.props.crewId,pageSize:this.state.perPageCount,page:previousPage});
        if(startIndex===0){
            this.setState({
                activePage: previousPage,
                startIndex : startIndex,
                endIndex : endIndex
            });  
        }else{
            this.setState({
                activePage: previousPage,
                startIndex : startIndex - PAGING_END_INDEX,
                endIndex : endIndex - PAGING_END_INDEX
            });  
        }                           
     }
  
     onPageUp = (e) => {
        this.props.crewTimesheetListAction({crew_id:this.props.crewId,pageSize:this.state.perPageCount,page:e.target.id});
        this.setState({
            activePage: Number(e.target.id)                   
        });
     }
  
     onPageNext = (e) =>{   
        const {
            startIndex,endIndex            
        } = this.state     
        const {
            totalPage            
        } = this.props
               
        let nextPage = startIndex+1+PAGING_END_INDEX;
        this.props.crewTimesheetListAction({crew_id:this.props.crewId,pageSize:this.state.perPageCount,page:nextPage});
        if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
            this.setState({
                activePage: nextPage,
                startIndex : startIndex,
                endIndex : endIndex
            }); 
        }else{
            this.setState({
                activePage: nextPage,
                startIndex : startIndex + PAGING_END_INDEX,
                endIndex : endIndex + PAGING_END_INDEX
            });  
        }                                   
     }

    render(){

        const {
            activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,actionNeeded, timesheetShiftList       
        } = this.state  

        let {crewTimesheetData,totalPage} = this.props;

        let isTimesheetModify = 0; 
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;

        let location = window.location; 
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        let profileCurrency = '';
        let supervisor = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            profileCurrency = userGroupData.profile_currency; 
            supervisor = userGroupData.supervisor_name; 
        }
        let timeZone =  getUserTimeZone(location);
        let rowNum = 0;

        return(
            <React.Fragment>
            <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
            <div className="col-md-12">
                <div className="box margin-top-12">
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:"100%"}}>
                            <thead>
                                <tr>
                                    <th className="phone " >{LBL_SHIFT+' @ '+LBL_EVENT_TITLE}</th>
                                    <th>{LBL_LOCATION}</th>
                                    <th>{LBL_START_CHECKIN_TIME} </th>
                                    <th>{LBL_END_CHECKOUT_TIME}  </th>
                                    <th className={this.state.isClientPage ? "hide" : "text-center min-width-120"}>{LBL_CREW_PAY} ({profileCurrency})</th>
                                    <th className="text-center">{LBL_SCHEDULED_HRS} </th>
                                    <th className="text-center">{LBL_ACTUAL_HRS} </th>
                                    <th className="text-center">{LBL_OT_HRS} </th>
                                    {isTimesheetModify > 0 &&
                                    <th className="text-center">{LBL_APPROVAL_STATUS} </th>
                                    }
                                    {isTimesheetModify > 0 &&
                                    <th className="action">&nbsp;</th>
                                    }
                                </tr>
                            </thead>
                            <tbody> 
                            
                            {!timesheetShiftList || !Array.isArray(timesheetShiftList) || timesheetShiftList.length===0  && 
                                    <tr>
                                        <td colSpan="12" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                
                            { timesheetShiftList &&  Array.isArray(timesheetShiftList) && timesheetShiftList.map((item, index)  => {
                                    let imageClass = item.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';
                                    let shift_start_time = converDateToLocal(item.shift_start_time,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                    let shift_end_time = converDateToLocal(item.shift_end_time,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                    let checkin_datetime = converDateToLocal(item.checkin_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                    let checkout_datetime = converDateToLocal(item.checkout_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                    let scheduled_hours = convertDecimalToHHMM(item.scheduled_hours);

                                    let profileImgTag = ''; // <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={item.crew_name} title={item.crew_name} />;

                                    let pay_level_name = item.pay_level_name && item.pay_level_name.length ? item.pay_level_name : ''; 
                                                let skill_name = item.skill_name && item.skill_name.length ? item.skill_name : '';
                                                const scheduleShiftStatus = SCHEDULE_CREW_STATUS.filter(x => Number(x.statusCode)===Number(item.schedule_status));
                                    const chiefIcon = item.is_crew_chief? <span><img className='cheifimg-icon' src={require('../../../'+ URL_IMG +'cheif.svg')}></img></span> :'';
                                    let over_time = convertDecimalToHHMM(item.over_time); 
                                    rowNum++; 
                                    let rowNumStr = rowNum.toString()
                                    return (
                                        <React.Fragment key={index}>
                                        <tr>
                                            <td>
                                                <span>{chiefIcon}</span>
                                                <b>{item.shift_title+' @ '+item.event_title}</b>
                                                {pay_level_name && pay_level_name.length > 1 && <p className="paddingTop0 paddingBottomp0"><small>{pay_level_name}</small></p>}
                                                {skill_name && skill_name.length > 1 && <p className="mb-0 text-12">{skill_name}</p>}
                                                {<p><span className={"status "+scheduleShiftStatus[0].colorClass}><small className="status-fill">{scheduleShiftStatus[0].statusString}</small></span></p>}
                                            </td>
                                            <td>{item.shift_location[0].location.venue}</td>
                                            <td><b>{shift_start_time}</b><br></br>{checkin_datetime}</td> 
                                            <td><b>{shift_end_time}</b><br></br>{checkout_datetime}</td>
                                            <td className={this.state.isClientPage ? "hide" : "text-right"}>
                                                {showStaffPayDetails(profileCurrency,supervisor,item)}
                                            </td> 

                                            <td className="text-center">{scheduled_hours}</td>

                                            <td className="text-center">{convertDecimalToHHMM(item.actual_hours)}</td>

                                            <td className="text-center">{over_time}</td>
                                            {isTimesheetModify > 0 &&
                                                <td className="text-center">
                                                    <span className={item.over_time_approval_status? "approved" : actionNeeded? "pending-underline" : item.over_time>0? "pending":""} onClick={actionNeeded? (e) => this.editBtnClick(e, item.id, item.timesheet_id, item.crew_profile_id, 'edit'): this.justClick()}></span></td>
                                                }
                                                {isTimesheetModify > 0 &&
                                                <td>
                                                    <div className={item.over_time_approval_status && this.state.isClientPage ? "hide" : actionNeeded ? "hide" : "dropdown"} id={'dropdown-'+rowNumStr}>
                                                    <button className="dropdown-toggle" type="button"
                                                        id={'dropdownMenuButton-'+rowNumStr} data-toggle="dropdown"
                                                        aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, rowNumStr)}
                                                        onBlur={(e) => this.onHideActionButtons(e, rowNumStr)}
                                                        >
                                                        <img id="test" src={require('../../'+URL_IMG+'action.png')} alt="Action" />
                                                    </button>
                                                    <div className="dropdown-menu" id={'dropdown-menu-'+rowNumStr}
                                                        aria-labelledby={'dropdownMenuButton-'+rowNumStr}>
                                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(e, item.id, item.timesheet_id, item.crew_profile_id, 'edit')}>{LBL_EDIT}</Link> 
                                                            
                                                    </div>
                                                    </div>
                                                </td>
                                            }
                                        </tr>
                                        </React.Fragment>
                                    )
                                })
                            }
                            </tbody>
                            </table>
                            <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                            <div className="clear-b-scroll-sector">&nbsp;</div>     
                            <div className="clear-b-scroll-sector">&nbsp;</div>                         
                            <div className="clear-b-scroll-sector">&nbsp;</div>    
                        </div>
                    </div>
                </div>

            </div>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        crewTimesheetData:state.crews.crewTimesheetData,
        status:state.crews.status,
        subactivity:state.crews.subactivity,  
        errorData:state.crews.errorData, 
        totalPage:state.crews.crewTimesheetTotalPage,
        numRows:state.crews.crewTimesheetNumRows,
        count:state.crews.crewTimesheetCount, 
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        crewTimesheetListAction:crewTimesheetListAction,  
        clearAction:clearAction   
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(CrewTimesheet);